
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/profile/general",
      function () {
        return require("private-next-pages/my-account/profile/general.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/profile/general"])
      });
    }
  